import { ProjectsService } from "../../services/projects/projects.service";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { LeadsService } from "../../services/lead-service/lead-service.service";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { ReservationService } from "../../services/reservation-service/reservation.service";
import swal from "sweetalert2";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";

@Component({
  selector: "app-fines",
  templateUrl: "./fines.component.html",
  styleUrls: ["./fines.component.scss"],
})
export class FinesComponent implements OnInit {
  reservations: Array<any> = [];
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));
  last_page_url: any;
  prev_page_url: any;
  current_page: any;
  filterForm: FormGroup;
  filterActive = false;
  filterData: any;
  is_refreshing = false;
  per_page: any;
  total: any;
  pageTest: any = 1;
  reservation_raw_data: any;
  manageTable: any = {
    lead_name: true,
    unit_serial: true,
    status: true,
    building: true,
    garden_area: true,
    price: true,
    date: true,
    agent: true,
    contract_generated: false,
    unit_area: true,
  };
  toogleManageTable = {
    lead_name: false,
    unit_serial: false,
    status: false,
    building: false,
    garden_area: false,
    price: false,
    date: false,
    agent: false,
    contract_generated: true,
    unit_area: false,
  };
  reservation = {
    onColor: "primary",
    offColor: "danger",
    onText: "Enable",
    offText: "Disable",
    value: "",
    size: "",
  };
  lg = "lg";
  projects: any;

  active_tab: any = "filter";
  constructor(
    private reservationService: ReservationService,
    private router: Router,
    public fb: FormBuilder,
    public slimLoadingBarService: SlimLoadingBarService,
    public errorHandlerService: ErrorHandlerService,
    public leadsService: LeadsService,
    private http: HttpClient,
    public projectService: ProjectsService
  ) {}

  ngOnInit() {
    this.createForms();
    this.getProjects();
    this.filterReservations();
  }

  createForms() {
    this.filterForm = this.fb.group({
      serial: [""],
      agent: [""],
      lead_name: [""],
      dealStatus: [""],
      project_id: [""],
      contract_type: [""],
      date_from: [""],
      date_to: [""],
    });
  }

  getProjects() {
    this.reservationService.getProjectsSelection().subscribe(
      (res: any) => {
        this.projects = res;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  filterReservations() {
    this.pageTest = 1;
    let payload = this.filterForm.value;
    payload.is_financial = 1;
    const formModel = Object.assign({}, payload);
    formModel.is_export = 0;

    this.slimLoadingBarService.start();
    this.filterActive = true;
    this.filterData = formModel;
    this.is_refreshing = true;
    this.reservationService
      .filterReservations(formModel)
      .subscribe((data: any) => {
        this.reservation_raw_data = data;
        this.last_page_url = data.last_page_url;
        this.current_page = 1;
        this.reservations = data.data;
        this.per_page = data.to;
        this.total = data.total;
        this.reservations = data.data;
        this.is_refreshing = false;
      }),
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
        this.is_refreshing = false;
      },
      () => {};
  }

  resetFilters() {
    this.filterActive = false;
    this.filterData = null;
    this.createForms();
    this.filterReservations();
  }

  infinite(url, number) {
    this.slimLoadingBarService.start();
    this.is_refreshing = true;
    this.leadsService.infinit(url).subscribe(
      (data: any) => {
        this.reservation_raw_data = data;
        this.reservations = data.data;
        this.current_page = number;
        this.per_page = data.to;
        this.total = data.total;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      },
      () => (this.is_refreshing = false)
    );
  }

  infiniteWithFilter(url, number) {
    this.slimLoadingBarService.start();
    this.is_refreshing = true;
    this.reservationService
      .infinitWithPagination(url, this.filterData)
      .subscribe(
        (data: any) => {
          this.reservation_raw_data = data;
          this.reservations = data.data;
          this.current_page = number;
          this.per_page = data.to;
          this.total = data.total;
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        },
        () => (this.is_refreshing = false)
      );
  }

  pageChange(event) {
    let arr = this.last_page_url.split("?");
    let selectedUrl = `${arr[0]}?page=${event}`;
    if (this.filterActive) {
      this.infiniteWithFilter(selectedUrl, event);
    } else {
      this.infinite(selectedUrl, event);
    }
  }

  toggleChange($event, type) {
    this.manageTable[type] = !$event;
  }

  gotoUnitView(reservation) {
    if (this.isCustomerCare() == true) return;
    this.router.navigate(["/pages/projects/view-unit"], {
      queryParams: {
        project_id: reservation.unit.project.id,
        unit_id: reservation.unit.id,
      },
    });
  }

  setFilterActiveTab() {
    if (this.active_tab == "" || this.active_tab == "sales-status") {
      this.active_tab = "filter";
    } else {
      this.active_tab = "";
    }
  }

  setSalesStatusTab() {
    if (this.active_tab == "" || this.active_tab == "filter") {
      this.active_tab = "sales-status";
    } else {
      this.active_tab = "";
    }
  }

  isCustomerCare() {
    return this.userProfile.role == "Customer Care" ? true : false;
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/fines/fines.component.ts